module.exports = __webpack_public_path__ + "static/media/wide.3b96bc4a.jpg";